import { updateQBVendor } from './updateQBVendor';
import { createQBVendor } from './createQBVendor';

export const upsertQBVendorLocal = async ({ qbId, qbDisplayName }) => {
  if (!qbId || !qbDisplayName) {
    console.warn('⚠️ upsertQBVendorLocal: missing qbId or qbDisplayName, skipping');
    return;
  }

  const input = {
    qbId: String(qbId),
    qbDisplayName,
    qbDisplayNameLower: qbDisplayName.toLowerCase(),
  };

  try {
    const result = await updateQBVendor(input);
    if (result) {
      console.log('✅ upsertQBVendorLocal: updated existing vendor', qbId);
      return result;
    }
  } catch (updateErr) {
    const isNotFound =
      updateErr?.errors?.[0]?.errorType === 'DynamoDB:ConditionalCheckFailedException' ||
      updateErr?.errors?.[0]?.message?.includes('No item found');

    if (!isNotFound) {
      console.error('❌ upsertQBVendorLocal: unexpected update error', updateErr);
      return;
    }
  }

  try {
    const result = await createQBVendor({ ...input, allSort: 'all' });
    console.log('✅ upsertQBVendorLocal: created new vendor', qbId);
    return result;
  } catch (createErr) {
    console.warn('⚠️ upsertQBVendorLocal: create failed (possible race condition)', createErr);
  }
};